import React from 'react';
import { SupportScreen } from '../domains/support/screens/SupportScreen';

export const SupportPage: React.FC = () => <SupportScreen />;
